import { useEffect, useState } from 'react';
import { Button, Form, Modal, DatePicker, message } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useHttp } from '@/shared/hooks/http.hook';

const ChangeLicenseModal = params => {
  const { request } = useHttp();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const getValidDate = date => {
    return date && dayjs(date).isValid() ? dayjs(date) : null;
  };

  useEffect(() => {
    form.setFieldsValue({
      license_expires: getValidDate(params.licenseExpires),
    });
  }, [params.licenseExpires, form]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const response = await request('/api/device/changeLicense', 'POST', {
        deviceId: params.id,
        license_expires: values.license_expires,
      });

      if (!response.error) {
        message.success('Лицензия обновлена');
        params.fetchListDevices(params.actualSegment);
        setIsModalOpen(false);
      } else {
        message.warning(response.message);
        console.error('Failed to update license ☹️');
      }
    } catch (error) {
      console.error('Error updating license:', error);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button type='dashed' style={{ position: 'absolute', right: '1px', top: '0px' }} onClick={showModal}>
        <EditOutlined />
      </Button>
      <Modal title='Изменение лицензии' open={isModalOpen} onOk={handleOk} onCancel={handleCancel} cancelText='Отмена'>
        <p>Выберите новый срок лицензии.</p>
        <Form form={form} initialValues={{ license_expires: getValidDate(params.licenseExpires) }}>
          <Form.Item
            label='Лицензия истекает:'
            name='license_expires'
            rules={[{ required: true, message: 'Пожалуйста, выберите дату!' }]}
          >
            <DatePicker placeholder='Выберите дату' />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ChangeLicenseModal;
